import { Deserializable } from '../protocols/deserializable';

export class SpousalVariableBenefitSourceAccountDetails implements Deserializable {
  public accountId!: number;
  public idPrefix!: string;
  public createdDate!: string;
  public specifiedBeneficiary!: { name: string; memberId: number | null } | null;
  public minimumAge!: { name: string; dateOfBirth: string; isSpouse: boolean };
  public effectiveYear!: number;
  public minimumAnnualWithdrawalAmount!: number;
  public struckOnBalance!: number | null;
  public struckOnDate!: string | null;
  public yearToDatePaymentAmount!: number;

  public onDeserialize(): void {}
}

export class SpousalVariableBenefitSourceAccount implements Deserializable {
  public memberId!: number;
  public activeSpouse!: { spouseId: number; name: string; linkedMemberId: number | null } | null;
  public account!: SpousalVariableBenefitSourceAccountDetails | null;

  public onDeserialize(): void {
    if (this.account) {
      this.account = window?.injector?.Deserialize?.instanceOf(
        SpousalVariableBenefitSourceAccountDetails,
        this.account
      );
    }
  }
}
